import { useState, useCallback } from 'react';

/**
 * 密码可见性切换Hook
 */
export const usePasswordVisibility = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const togglePassword = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  const togglePasswordConfirm = useCallback(() => {
    setShowPasswordConfirm((prev) => !prev);
  }, []);

  const hideAll = useCallback(() => {
    setShowPassword(false);
    setShowPasswordConfirm(false);
  }, []);

  return {
    showPassword,
    showPasswordConfirm,
    togglePassword,
    togglePasswordConfirm,
    hideAll,
  };
};
